import { MODULOS_VALORES_PADRAO, FUNCIONALIDADES_VALORES_PADRAO } from 'src/core/modulos'
/*
  Modulos do sistema.
  O valor dos modulos, exceto o modulo_base, são definidos no Flagsmith.

  Os valores são recuperados através do serviço Flagsmith após o login do usuário.

  O modulo_base é um modulo padrão do sistema, e não pode ser desativado.
*/


export default {
  state: {
    modulos: {
      modulo_base: MODULOS_VALORES_PADRAO.modulo_base,
      registro_de_ponto: MODULOS_VALORES_PADRAO.registro_de_ponto,
      reducao_de_riscos: MODULOS_VALORES_PADRAO.reducao_de_riscos,
      calculos_e_tratamentos: MODULOS_VALORES_PADRAO.calculos_e_tratamentos,
      gestao_participativa: MODULOS_VALORES_PADRAO.gestao_participativa,
      controle_custos: MODULOS_VALORES_PADRAO.controle_custos,
      timesheet: MODULOS_VALORES_PADRAO.timesheet,
      gestao_de_ferias_e_ausencias: MODULOS_VALORES_PADRAO.gestao_de_ferias_e_ausencias,
      legado: MODULOS_VALORES_PADRAO.legado,
    },
    funcionalidades: {
      notificacoes_lembrete_horario_ponto_empregado: FUNCIONALIDADES_VALORES_PADRAO.notificacoes_lembrete_horario_ponto_empregado,
      notificacoes_pontos_batidos_gestor: FUNCIONALIDADES_VALORES_PADRAO.notificacoes_pontos_batidos_gestor,
      medidas_basicas_antifraude_foto_voz_recaptcha: FUNCIONALIDADES_VALORES_PADRAO.medidas_basicas_antifraude_foto_voz_recaptcha,
      medidas_avancadas_antifraude_reconhecimento_facial: FUNCIONALIDADES_VALORES_PADRAO.medidas_avancadas_antifraude_reconhecimento_facial,
      medidas_avancadas_antifraude_geolocalizacao: FUNCIONALIDADES_VALORES_PADRAO.medidas_avancadas_antifraude_geolocalizacao,
      medidas_avancadas_antifraude_manipulacao_horario: FUNCIONALIDADES_VALORES_PADRAO.medidas_avancadas_antifraude_manipulacao_horario,
      medidas_avancadas_antifraude_bloqueio_ip: FUNCIONALIDADES_VALORES_PADRAO.medidas_avancadas_antifraude_bloqueio_ip,
      notificacoes_acionaveis_gestor_atraso_hora_extra: FUNCIONALIDADES_VALORES_PADRAO.notificacoes_acionaveis_gestor_atraso_hora_extra,
      sobreaviso: FUNCIONALIDADES_VALORES_PADRAO.sobreaviso,
      painel_acompanhamento_apontamentos_eventos: FUNCIONALIDADES_VALORES_PADRAO.painel_acompanhamento_apontamentos_eventos,
      solicitacoes_tratamento_folha: FUNCIONALIDADES_VALORES_PADRAO.solicitacoes_tratamento_folha,
      solicitacoes_mudanca_escala: FUNCIONALIDADES_VALORES_PADRAO.solicitacoes_mudanca_escala,
      solicitacoes_banco_horas: FUNCIONALIDADES_VALORES_PADRAO.solicitacoes_banco_horas,
      governanca_fechamento_travamento_bilateral: FUNCIONALIDADES_VALORES_PADRAO.governanca_fechamento_travamento_bilateral,
      planejamento_escalas: FUNCIONALIDADES_VALORES_PADRAO.planejamento_escalas,
      acompanhamento_tempo_real: FUNCIONALIDADES_VALORES_PADRAO.acompanhamento_tempo_real,
      gestao_horas_extras_solicitacoes: FUNCIONALIDADES_VALORES_PADRAO.gestao_horas_extras_solicitacoes,
      gestao_horas_extras_limite_acompanhamento: FUNCIONALIDADES_VALORES_PADRAO.gestao_horas_extras_limite_acompanhamento,
      gestao_horas_extras_notificacoes: FUNCIONALIDADES_VALORES_PADRAO.gestao_horas_extras_notificacoes,
      solicitacoes_ferias: FUNCIONALIDADES_VALORES_PADRAO.solicitacoes_ferias,
      acompanhamento_ferias: FUNCIONALIDADES_VALORES_PADRAO.acompanhamento_ferias,
      acesso_ferramenta_crisp: FUNCIONALIDADES_VALORES_PADRAO.acesso_ferramenta_crisp,
      acesso_seletor_internacionalizacao: FUNCIONALIDADES_VALORES_PADRAO.acesso_seletor_internacionalizacao,
      visualizar_pesquisa_de_produto: FUNCIONALIDADES_VALORES_PADRAO.visualizar_pesquisa_de_produto,
      funcionalidade_ia_dispensas: FUNCIONALIDADES_VALORES_PADRAO.funcionalidade_ia_dispensas,
      funcionalidade_ia_calendario_ferias: FUNCIONALIDADES_VALORES_PADRAO.funcionalidade_ia_calendario_ferias,
      funcionalidade_ia_gestao_horas_extras: FUNCIONALIDADES_VALORES_PADRAO.funcionalidade_ia_gestao_horas_extras,
      acesso_auditoria_detalhada: FUNCIONALIDADES_VALORES_PADRAO.acesso_auditoria_detalhada,
      acesso_auditoria_de_integracoes: FUNCIONALIDADES_VALORES_PADRAO.acesso_auditoria_de_integracoes,
      acesso_refatoracao_folha: FUNCIONALIDADES_VALORES_PADRAO.acesso_refatoracao_folha,
      acesso_funcionalidade_verificar_dia: FUNCIONALIDADES_VALORES_PADRAO.acesso_funcionalidade_verificar_dia,
      acesso_ao_cadastro_de_biometria_facial: FUNCIONALIDADES_VALORES_PADRAO.acesso_ao_cadastro_de_biometria_facial,
      acesso_banner_gestao_beta: FUNCIONALIDADES_VALORES_PADRAO.acesso_banner_gestao_beta,
      escala_temporaria: FUNCIONALIDADES_VALORES_PADRAO.escala_temporaria,
      acesso_timesheet: FUNCIONALIDADES_VALORES_PADRAO.acesso_timesheet,
      sistema_de_ponto_com_atividades: FUNCIONALIDADES_VALORES_PADRAO.sistema_de_ponto_com_atividades,
      gerar_r01_apos_travamento_unilateral: FUNCIONALIDADES_VALORES_PADRAO.gerar_r01_apos_travamento_unilateral,
      funcionalidade_ia_politica_fechamento: FUNCIONALIDADES_VALORES_PADRAO.funcionalidade_ia_politica_fechamento,
      assistente_pontotel_habilitado: FUNCIONALIDADES_VALORES_PADRAO.assistente_pontotel_habilitado,
      controle_de_estacoes: FUNCIONALIDADES_VALORES_PADRAO.controle_de_estacoes,
      ponto_por_whatsapp: FUNCIONALIDADES_VALORES_PADRAO.ponto_por_whatsapp,
      ambiente_demo_comercial: FUNCIONALIDADES_VALORES_PADRAO.ambiente_demo_comercial
    }
  },
  getters: {},
  mutations: {
    DEFINIR_MODULOS (state, modulos) {
      for (const [key, value] of Object.entries(modulos)) {
        state.modulos[key] = value
      }
    },
    DEFINIR_FUNCIONALIDADES (state, funcionalidades) {
      for (const [key, value] of Object.entries(funcionalidades)) {
        state.funcionalidades[key] = value
      }
    }
  },

  actions: {}
}
